import { render } from "./UltraBox.vue?vue&type=template&id=031abf64&scoped=true"
import script from "./UltraBox.vue?vue&type=script&lang=js"
export * from "./UltraBox.vue?vue&type=script&lang=js"

import "./UltraBox.vue?vue&type=style&index=0&id=031abf64&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031abf64"]])

export default __exports__